import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/school-classes/")({
  beforeLoad: () => {
    throw redirect({
      to: "/groups",
    });
  },
});
